export function ShowFadeInUpSection(nomeClasse, startTime = .2) {//aqui é para a animação de quando ve a seção pos-vantagens
    if (!nomeClasse) { return }
    const target = document.querySelector(`.${nomeClasse}`);
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('ShowFadeInUpSection');
                observer.unobserve(entry.target); // Remove o observador após a primeira exibição
            } else {
                entry.target.style.opacity = '0';
            }
        });
    }, {
        threshold: 0.2 // 30% da seção visível já ativa a animação
    });

    if (target) {

        setTimeout(() => {
            observer.observe(target)
        }, startTime * 1000);
    }
}